(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleDialogController', VentadetalleDialogController);

    VentadetalleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventadetalle'];

    function VentadetalleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventadetalle) {
        var vm = this;

        vm.ventadetalle = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventadetalle.id !== null) {
                Ventadetalle.update(vm.ventadetalle, onSaveSuccess, onSaveError);
            } else {
                Ventadetalle.save(vm.ventadetalle, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventadetalleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
